import { useState, useEffect } from "react";
import { RuvnlTitle } from "../components";
import OverviewPrice from "./Overview_price";
import RajOverview from "./EntityAnalysis";
import { NewDynamicTab } from "../../../components/Page";
import { TabSwitcher } from "../Raj_Dashboard";
import { RuvitalOverview } from "../../../config/DefaultDates";

const TABS = ["Procurement Vs Consumption", "Entity Analysis"];

export function DemoRajasthanOverview() {
  // Get initial tab from URL or default to "Restricted Demand"
  const initialTab =
    new URLSearchParams(window.location.search).get("tab") || TABS[0];
  const [selectedTab, setSelectedTab] = useState(initialTab);

  useEffect(() => {
    // Update selected tab if URL changes
    const handlePopState = () => {
      const tab = new URLSearchParams(window.location.search).get("tab");
      if (tab && TABS.includes(tab)) {
        setSelectedTab(tab);
      }
    };

    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, []);

  return (
    <NewDynamicTab
      defaultDates={RuvitalOverview}
      headerPrefixComponent={<TabSwitcher />}
      middleComponent={<RuvnlTitle />}
      header="Overview"
      tabs={{
        // 'Dashboard': <OverviewDas />,
        "By Summary": <RajOverview />,
        "By Product": <OverviewPrice />,
      }}
    />
  );
}
